import _ from 'lodash'
import { Grants, Permissions } from './models/permissions.model'
import { ParsedRole } from './models/parsedRole.model'
import { ParsedToken } from './models/token.model'
import { KeycloakTokenParsed } from 'keycloak-js'

export function parseToken(
  keycloakToken: ParsedToken | KeycloakTokenParsed,
  clientId: string,
): Permissions {
  const clientRoles = _.get(
    keycloakToken,
    `resource_access.${clientId}.roles`,
    [],
  ).map(role => role.toLowerCase())

  const isAdmin = clientRoles.includes('administrator')

  const parsedRole = {
    isAdmin,
    bu_manager: clientRoles.includes('bu_manager'),
    jobsite_manager: clientRoles.includes('jobsite_manager'),
    zl_admin: clientRoles.includes('zl_admin'),
    zl_no_matomo: clientRoles.includes('zl-no-matomo'),
  }
  return {
    parsedRole: parsedRole,
    canCreate: isAdmin,
    editTechniquesList: isAdmin,
    canConfigure: isAdmin,
    grants: getGrants(parsedRole),
  }
}

function getGrants({
  zl_admin,
  jobsite_manager,
  bu_manager,
}: ParsedRole): Grants {
  return {
    companyWorkdayDuration: zl_admin || bu_manager,
    configFeaturesToggles: zl_admin,
    asbuiltChecks: zl_admin || bu_manager || jobsite_manager,
    asbuiltCompanyTemplate: zl_admin || bu_manager,
    asbuiltJobsiteTemplate: zl_admin || jobsite_manager || bu_manager,
    companyCsvSettings: zl_admin || bu_manager,
    companyDateTimePreferences: zl_admin || bu_manager,
    companyTimezone: zl_admin || bu_manager,
    compoundParams: zl_admin || bu_manager || jobsite_manager,
    defaultHomePage: zl_admin || bu_manager || jobsite_manager,
    editGeneralInformation: zl_admin || bu_manager || jobsite_manager,
    editLayout: zl_admin || bu_manager || jobsite_manager,
    jobsiteWorkdayDuration: zl_admin || bu_manager || jobsite_manager,
    manageMachineWorkingHours: zl_admin || bu_manager || jobsite_manager,
    sendInstructions: zl_admin || bu_manager || jobsite_manager,
    setCompanyTemplate: zl_admin || bu_manager,
    setJobsiteListKpi: zl_admin || jobsite_manager,
    setJobsiteFavoriteKpi: zl_admin || bu_manager,
    setJobsiteTemplate: zl_admin || bu_manager || jobsite_manager,
    tagAsDone: zl_admin || bu_manager || jobsite_manager,
    updateJobsiteStatus: zl_admin || bu_manager || jobsite_manager,
    updatePlannedProgress: zl_admin || bu_manager || jobsite_manager,
    weeklyReportConfig: zl_admin || bu_manager,
    companyTabsSettings: zl_admin || bu_manager,
  }
}
